import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";

export default function DeleteFamilyMemberDialog({ open, onClose, onDelete, member }) {
    const handleDelete = () => {
        onDelete(member);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle>Familienmitglied löschen</DialogTitle>
            <DialogContent>
                <Typography>
                    Möchten Sie wirklich löschen{" "}
                    <strong>{member ? `${member.firstName} ${member.lastName}` : ""}</strong>?
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ width: '100%', marginBottom: '5px'}}>
                    <Button
                        variant="contained"
                        color="error"
                        startIcon={<DeleteIcon />}
                        onClick={handleDelete}
                    >
                        Löschen
                    </Button>

                    <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<CancelIcon />}
                        onClick={onClose}
                    >
                        Stornieren
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}